import React, { useEffect, useState } from "react";
import Button from "../common/Button/Button";
import api from "../../services/api";
import { toast } from "react-toastify";
import styles from "./NotificationQuery.module.css";

const AddNotificationQuery = ({ queryId, onSubmitted, onCancel }) => {
    const id = queryId;
    const [formData, setFormData] = useState({
        title: "",
        query: "",
    });

    useEffect(() => {
        if (id) {
            api.get(`/notification-query/${id}`)
                .then((res) => {

                    const notification = res.result?.[0];
                    if (notification) {
                        setFormData({
                            title: notification.title || "",
                            message: notification.message || "",
                            query: notification.queries || "",
                            notificationtype: notification.notificationtypeid,
                        });
                    }
                })
                .catch((err) => console.error("Error loading notification:", err));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            title: formData.title,
            query: formData.query,
        }

        const apiCall = id
            ? api.put(`/notification-query/${id}`, payload)   // Edit mode
            : api.post(`/notification-query`, payload);       // Add mode

        apiCall
            .then(() => { if (onSubmitted) onSubmitted(); })
            .catch((error) => console.error("Error:", error));
    };

    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">


                <form onSubmit={handleSubmit} className="moduleForm">

                    <div className="formGrid">
                        <div className="formGroup">
                            <label>Query Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="formGroup">
                            <label>Query</label>
                            <textarea
                                name="query"
                                value={formData.query}
                                onChange={handleChange}
                                className={`${styles.textarea} ${styles.minH5}`}
                                required
                                rows={10}
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddNotificationQuery;